import React, { useState, useEffect, useMemo, useCallback } from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useSelector, useDispatch } from 'react-redux';
import { changeFilters } from 'redux-api/action/filters';
import { getPresetRequest, putPresetRequest, delPresetRequest } from 'redux-api/action/preset';
import selectPreset from 'redux-api/reselect/preset';
import Modal from 'theme/modal';
import translations from 'translations';
import Search from './search';
import PresetItem from './preset-item';

const Wrapper = styled.div`
  width: 100%;

  & > .presets-list {
    width: 100%;
    padding-top: ${themeGet('space.m')}px;

    & > .preset-wrap {
      width: 100%;
      border-bottom: 2px solid ${themeGet('colors.primary_50')};
    }

    & > .preset-wrap:last-child {
      border-bottom: none;
    }
  }
`;

function ManagePreset({ isVisible, onClose, languageCode }) {
  const dispatch = useDispatch();

  const [searchInput, setSearchInput] = useState('');

  const { isWaiting, error } = useSelector((state) => state.preset);
  const payload = useSelector(selectPreset);

  useEffect(() => {
    dispatch(getPresetRequest());
  }, [dispatch]);

  const presets = useMemo(() => {
    if (!payload.presets) return [];

    return payload.presets.filter((preset) =>
      preset.title.toLowerCase().includes(searchInput.toLowerCase()),
    );
  }, [payload, searchInput]);

  const handleSelect = useCallback(
    (p) => {
      onClose();
      dispatch(changeFilters(p));
    },
    [dispatch, onClose],
  );

  const handleEdit = useCallback(
    (title, changedTitle) => {
      dispatch(
        putPresetRequest({
          presetId: title,
          preset: {
            ...payload,
            title: changedTitle,
          },
        }),
      );
    },
    [dispatch, payload],
  );

  const handleDelete = useCallback(
    (p) => {
      dispatch(delPresetRequest(p.title));
    },
    [dispatch],
  );

  return (
    <Modal
      isVisible={isVisible}
      onClose={onClose}
      title={translations[languageCode]['manage preset']}
      bgColor="white"
      width="480px"
    >
      <Wrapper>
        <Search
          placeholder={translations[languageCode].search}
          value={searchInput}
          onChange={setSearchInput}
        />

        <div className="presets-list">
          {presets.map((preset) => (
            <div key={preset.title} className="preset-wrap">
              <PresetItem
                languageCode={languageCode}
                payload={preset}
                onSelect={handleSelect}
                onEdit={handleEdit}
                onDelete={handleDelete}
                isWaiting={isWaiting}
                error={error}
              />
            </div>
          ))}
        </div>
      </Wrapper>
    </Modal>
  );
}

export default ManagePreset;
